import { CAFirmServices } from './types';

export function getPrintableCAFirmService(service: CAFirmServices) {
  const serviceMap: Record<CAFirmServices, string> = {
    [CAFirmServices.INCORPORATION]: 'Incorporation',
    [CAFirmServices.ODI]: 'ODI',
    [CAFirmServices.FDI]: 'FDI',
    [CAFirmServices.DIRECT_TAXES]: 'Direct Taxes',
    [CAFirmServices.INDIRECT_TAXES]: 'Indirect Taxes',
    [CAFirmServices.HR_AND_PAYROLL]: 'HR & Payroll',
    [CAFirmServices.TRANSFER_PRICING]: 'Transfer Pricing',
    [CAFirmServices.SALES_TAX]: 'Sales Tax',
  };

  return serviceMap[service];
}
